import { render, staticRenderFns } from "./SickLeaveList.vue?vue&type=template&id=21e11ace&scoped=true&"
import script from "./SickLeaveList.vue?vue&type=script&lang=ts&"
export * from "./SickLeaveList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e11ace",
  null
  
)

export default component.exports